'use client';

import React from 'react';
import { SliceComponentProps } from '@prismicio/react';
import styles from './how-it-works.module.scss';
import { Button } from '@get-mosh/msh-shared';
import { trackClick } from 'src/analytics/Events';
import EventNames from 'src/analytics/EventNames';
import { Content } from '@prismicio/client';
import { Vertical } from 'src/constants/Verticals';
import { PrismicNextImage } from '@prismicio/next';

type HowItWorksProps = SliceComponentProps<Content.HowItWorksSlice> & {
    context: { pageType: string };
};

const HowItWorks = ({ slice, context }: HowItWorksProps) => {
    return (
        <section className="container mx-auto py-8 lg:py-16 xl:max-w-screen-xl">
            {slice?.primary?.title && (
                <h2 className="mb-2 text-center">{slice.primary.title}</h2>
            )}
            <div className={styles['items']}>
                {slice?.items?.length > 0 &&
                    slice.items.map((item, i) => {
                        return (
                            <div
                                className="mb-4 w-full text-center md:mb-0 md:w-1/3"
                                key={i}
                            >
                                {item?.image?.url && (
                                    <picture
                                        className={styles['item-image-wrapper']}
                                    >
                                        <PrismicNextImage field={item.image} />
                                    </picture>
                                )}
                                <h3>{item.title}</h3>
                                <p className="pb-4">{item.description}</p>
                            </div>
                        );
                    })}
            </div>
            {slice?.primary?.cancel_text && (
                <p className="-mt-4 text-center font-bolder text-sm underline md:mt-0 lg:text-base">
                    Cancel anytime without fees.
                </p>
            )}
            <div className="mt-8 flex items-center justify-center">
                <Button
                    text={slice.primary.link_label || 'Learn More'}
                    as="a"
                    href={slice.primary.link_path || '/'}
                    onClick={() => {
                        trackClick(EventNames.BUTTON_CLICKED, {
                            pageType: context.pageType,
                            vertical: slice.primary.vertical as Vertical,
                            label: slice.primary.link_label || 'Learn More',
                            link: slice.primary.link_path || '/',
                            variation: slice.variation,
                            location: slice.slice_type,
                        });
                    }}
                />
            </div>
        </section>
    );
};

export default HowItWorks;
